import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhutixinxi",
  "use": "icon-zhutixinxi-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 14\" id=\"icon-zhutixinxi\"><path d=\"M7.5 0l2.318 4.609L15 5.348l-3.75 3.587.885 5.065L7.5 11.609 2.865 14l.885-5.065L0 5.348l5.182-.74L7.5 0zm0 1.935L5.762 5.39l-3.887.554 2.813 2.69-.664 3.8L7.5 10.64l3.476 1.794-.664-3.8 2.813-2.69-3.887-.554L7.5 1.935z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/zhutixinxi.svg
// module id = 538
// module chunks = 4